import bigcommerceGenericDefaults from '../bigcommerce-generic/config.js';

const baseFitmentFields = window.Convermax.config?.baseFitmentFields || ['Year', 'Make', 'Model', 'Submodel'];

window.Convermax.isLoggedIn = window.document.querySelector('#menuLoggedIn');

function getActiveCurrency() {
  return window.Convermax?.BigCommerce?.currency;
}

export function createPriceFormatter(locale) {
  return function formatPrice(price) {
    if (!price) {
      return '';
    }

    const activeCurrency = getActiveCurrency();
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: activeCurrency,
    }).format(price);
  };
}

function InitFunc() {
  bigcommerceGenericDefaults.InitFunc?.();

  if (window.document.querySelector('#cm_results, #cm-brand-list, #cm-category-list')) {
    const unwantedPageWrappers = [
      ['.page.page-container', 'page'],
      ['.page.page-container', 'page-container'],
    ];

    unwantedPageWrappers.forEach(([elemSelector, className]) => {
      const wrapperElem = window.document.querySelector(elemSelector);
      wrapperElem?.classList.remove(className);

      if (wrapperElem && !wrapperElem.classList.contains('wide')) {
        wrapperElem.classList.add('wide');
      }
    });
  }
}

function AfterInit() {
  bigcommerceGenericDefaults.AfterInit?.();

  const header = document.querySelector('header .header-main');
  if (!header) {
    return;
  }

  const headerHeight = header.offsetHeight;

  window.addEventListener('scroll', () => {
    if (window.scrollY > headerHeight) {
      header.classList.add('cm_hide');
    } else {
      header.classList.remove('cm_hide');
    }
  });
}

export default {
  includes: ['bigcommerce-generic'],
  ...bigcommerceGenericDefaults,
  InitFunc,
  AfterInit,
  SearchRequestDefaults: {
    ...bigcommerceGenericDefaults.SearchRequestDefaults,
    pageSize: 48,
    extra: {
      currency: getActiveCurrency(),
    },
  },
  autocomplete: {
    requestDefaults: {
      extra: {
        currency: getActiveCurrency(),
      },
    },
  },
  product: {
    formatPrice: createPriceFormatter('sv-SE'),
  },
  Widgets: [
    ...bigcommerceGenericDefaults.Widgets.filter(
      (w) =>
        !['SearchResult', 'HeaderVehicleWidget', 'SearchVehicleWidget', 'VerifyFitment'].includes(w.name),
    ),
    {
      name: 'CategoryPageCategoriesGrid',
      type: 'FacetTiles',
      location: '#cm-categories-grid-list',
      template: 'facetTiles/subtitles',
      view: 'grid',
      facetField: 'category',
      visibleIf: () => window.location.pathname !== '/categories/',
    },
    {
      name: 'SearchResult',
      infiniteScrollDisabled: true,
    },
    {
      name: 'SearchVehicleWidget',
      type: 'VehicleWidget',
      location: '#cm-ymm',
      template: 'fitmentSearch/collapsibleVehicleWidget',
      isAlwaysActive: true,
      columnBreakpoint: 650,
      initCollapsed: true,
      fields: !!window.Convermax.config?.extraFieldsAsFilters && baseFitmentFields,
      isVehicleSelectionIsolated: !!window.Convermax.config?.isVehicleSelectionIsolated,
      visibleIf: () =>
        window.location.pathname.includes('/c/') ||
        window.location.pathname.includes('/sokresultat/') ||
        window.location.pathname.includes('/search/'),
    },
    {
      name: 'VerifyFitment',
      location: '#cm-verify-fitment',
      template: 'fitmentSearch/verifyFitment',
      columnBreakpoint: 395,
    },
  ],
};
